import { load } from "../../events/load";

/**
 * Back to Top Button Logic
 * Shows button on scroll and scrolls to top on click.
 */
const initBackToTop = () => {
    const backToTopBtn = document.getElementById("back-to-top");

    if (!backToTopBtn) return;

    // Toggle visibility based on scroll position
    const handleScroll = () => {
        if (window.scrollY > 400) {
            backToTopBtn.classList.add("is-visible");
        } else {
            backToTopBtn.classList.remove("is-visible");
        }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Initial check
    handleScroll();

    // Smooth scroll to top on click
    backToTopBtn.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
};

load(initBackToTop);

export default initBackToTop;
